
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import ConfirmPaymentItem from "@/views/purchase/components/confirm-payment.vue";
import RegisterInvoice from "@/views/purchase/components/register-invoice.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
const service = namespace("service");
const base = namespace("base");
const purchase = namespace("purchase");

@Component({
  components: { ConfirmPaymentItem, RegisterInvoice }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("login.password-empty-tips"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class SelectPurchaseModal extends Vue {
  dayjs = dayjs;
  @Prop({ default: "" })
  supplierCode: string;
  @Prop({ default: false })
  visible: boolean;

  @base.Action getDictionaryList;
  @purchase.Action getPurchaseList;
  @service.Action createInvoice;
  @purchase.Action createPurchasePayment;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  orderList: any[] = [];
  searchForm = {
    purchaseNo: "",
    supplierCode: "",
    purchaseStatus: "",
    settlementStatus: "0",
    purchaseDateBegin: "",
    purchaseDateEnd: ""
  };
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  orderStatusList: any[] = [];
  get $supplierCode() {
    return this.supplierCode;
  }
  get $visible() {
    return this.visible;
  }
  created() {
    this.init();
  }
  settlementList: any = [];
  init() {
    // 结算方式字典List
    this.getDictionaryList("purchase_settlement_status").then(data => {
      this.settlementList = data;
    });
    // 订单状态字典List
    this.getDictionaryList("purchase_status_settlement_select").then(data => {
      this.orderStatusList = data;
    });
    // 开票状态字典List
    this.getDictionaryList("invoice_status").then(data => {
      this.invoiceStatusList = data;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    this.searchForm.supplierCode = this.$supplierCode;
    return this.getPurchaseList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      excludePurchaseStatus: "9",
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  handleConfirmSelect() {
    this.$emit("update:visible", false);
    this.$emit("confirmSelected", this.mix_selectedRows);
  }
  handleClose() {
    this.$emit("update:visible", false);
  }
  invoiceStatusList: any = [];
  get searchList() {
    return [
      {
        label: this.$t("base.order-status"),
        type: "select",
        selectList: this.orderStatusList,
        value: "",
        prop: "purchaseStatus"
      },

      {
        label: this.$t("base.make-invoice-status"),
        type: "select",
        selectList: this.invoiceStatusList,
        value: "",
        prop: "invoiceStatus"
      },
      {
        label: this.$t("purchase.purchase-date"),
        type: "daterange",
        value: "",
        prop: "purchaseDate"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "purchaseDate") {
          this.searchForm["purchaseDateBegin"] = item.value ? item.value[0] : "";
          this.searchForm["purchaseDateEnd"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  getSelectedRow() {
    return this.mix_selectedRows;
  }
  handleEdit(row) {
    this.$router.push(`/purchase/purchase-edit/${row.purchaseNo}`);
  }
  currentSupplierCode: string = "";
  handleOpen() {
    if (this.supplierCode !== this.currentSupplierCode) {
      this.currentSupplierCode = this.supplierCode;
      this.loadListData();
    }
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${row.purchaseNo}`
    });
    window.open(href, "_blank");
  }
}
